export default function (...fields) {
  const validate = [...fields];
  return validate.some((field) => {
    return !field;
  });
}
